import { createSelector } from '@reduxjs/toolkit';
import { State } from 'state';
import { IArticleItem, RunningBulkAction } from '../types/articleItem';

const selectArticlesState = (state: State) => state.moderation.articles;

export const selectSpotPolicy = createSelector(selectArticlesState, state => state.spotPolicy);
export const selectArticlesList = createSelector(selectArticlesState, state => state.articles);
export const selectArticlesCount = createSelector(
  selectArticlesState,
  state => state.articlesCount
);
export const selectArticlesListIds = createSelector(selectArticlesList, articlesList =>
  articlesList.map(({ conversationId }) => conversationId)
);
export const selectArticleById = (state: State, articleId: string): IArticleItem => {
  const articlesList = selectArticlesList(state);
  return articlesList.find(({ conversationId }) => conversationId === articleId);
};
export const selectArticleByPostId = (state: State, postId: string): IArticleItem => {
  const articlesList = selectArticlesList(state);
  return articlesList.find(({ postId: articlePostId }) => articlePostId === postId);
};
export const selectIsArticlesListLoading = createSelector(
  selectArticlesState,
  state => state.isLoading
);
export const selectArticlesCurrentPage = createSelector(
  selectArticlesState,
  state => state.currentPage
);
export const selectArticlesSearchBy = createSelector(selectArticlesState, state => state.searchBy);
export const selectArticlesSearchValue = createSelector(
  selectArticlesState,
  state => state.searchValue
);
const selectArticlesFilter = createSelector(selectArticlesState, state => state.filter);
export const selectArticlesFilterTags = createSelector(selectArticlesFilter, state => state.tags);
export const selectArticlesFilterOffset = createSelector(
  selectArticlesFilter,
  state => state.offset
);
export const selectArticlesAppliedFilterTags = createSelector(
  selectArticlesFilter,
  state => state.appliedTags
);
export const selectArticlesAppliedFiltersCount = createSelector(
  selectArticlesAppliedFilterTags,
  tags => tags.length
);
export const selectArticlesSortBy = createSelector(selectArticlesState, state => state.sortBy);
export const selectArticleRunningBulkActions = (state: State): Array<RunningBulkAction> => {
  return state.moderation.articles.runningBulkActions;
};
export const selectArticlesPostIdsForPolling = (state: State): Array<string> => {
  return selectArticleRunningBulkActions(state).map(({ postId }) => postId);
};
